module.exports = __webpack_public_path__ + "img/logo.3c17d37e.png";